// extracted by mini-css-extract-plugin
export var contacts = "RequestConsultation-module--contacts--1147f";
export var container = "RequestConsultation-module--container--e227c";
export var desktopHidden = "RequestConsultation-module--desktopHidden--405df";
export var fadeInAnimation = "RequestConsultation-module--fadeInAnimation--edfbd";
export var formWrap = "RequestConsultation-module--formWrap--45ed3";
export var loaderWrap = "RequestConsultation-module--loaderWrap--39e58";
export var mobileHidden = "RequestConsultation-module--mobileHidden--ce771";
export var subtitle = "RequestConsultation-module--subtitle--5e0a5";
export var title = "RequestConsultation-module--title--a3b34";
export var withoutAside = "RequestConsultation-module--withoutAside--377d1";